// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sample[data-v-3d95cd36]{padding:30px 40px}.sample li[data-v-3d95cd36]{margin:10px 0;font-size:30px}.sample li a[data-v-3d95cd36]{color:#000}.sample li .disabled[data-v-3d95cd36]{color:red;cursor:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
